import React, { MouseEvent, useEffect, useRef, useState } from 'react'
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import { getNote, updateNote } from '../../loaders/notes-loader';
import { FullReportEntry } from '../../models/FullReportEntry';


function ObsEditor({onSave, content}:{onSave:(a: string)=>void, content:string}){
    const [txt, setTxt] = useState(content);
    const ref = useRef<HTMLTextAreaElement>(null);

    useEffect(()=>{ref.current.focus()}, []);

    return <textarea ref={ref} rows={5} className="form-control" value={txt} onChange={(e) => setTxt(e.target.value) } onBlur={() => onSave(txt)} />
}

export function Observation({account}:{account:FullReportEntry}){
    const [loading, setLoading] = useState(true);
    const [editMode, setEditMode] = useState(false)
    const [content, setContent] = useState("")
    
    useEffect(() => {
       (async () =>{
            const note = await getNote(account.id);
            if(note)
                setContent(note.content)
            setLoading(false);
       })()
    }, []);

    async function updateContent(c:string){
        setContent(c); 
        setEditMode(false);
        const note = await updateNote(account.id, c)
        console.log(note);
    }

    function onclick(e:MouseEvent){
        const isA = (e.target as HTMLElement).nodeName == 'A';
        e.stopPropagation();
        e.preventDefault();

        if(isA){
            window.open((e.target as HTMLAnchorElement).href, '_blank');
            return;
        }

        setEditMode(true)
    }

    if(loading) return  <>
        <h3>Observação Geral</h3>
        <span className='text-muted'>Carregando...</span>
    </>;

    if(editMode) return  <>
         <h3>Observação Geral</h3>
        <ObsEditor onSave={updateContent} content={content} />
    </>;

    return <>
        <h3>Observação Geral</h3>
        <div className="main-obs" onClick={onclick}>
            {content && <ReactMarkdown remarkPlugins={[gfm]}>{content}</ReactMarkdown>}
            {!content && <span className='text-muted'>Nenhuma obserção registrada</span>}
        </div>

    </>
}

